var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('height:'+_vm.screenHeight+'px;')},[_c('img',{style:('width: 100%; height: '+_vm.screenHeight+'px;'),attrs:{"src":require("../assets/pantalla/mobi.jpg")}}),_c('img')])}
var staticRenderFns = []

export { render, staticRenderFns }